const ElementExists = selector => {
    return document.querySelector(selector) ? true : false;
}

export default ElementExists;